$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function pixImageUrl(mode, size, path, nocache) {
    if (nocache) mode = 'nocache-' + mode;
    return '/piximage/' + mode + '/' + size + path;
}

$('.jsLink').click(function () {
    window.location.href = $(this).data('url');
});

function rand(min, max) {
    max += 1;
    return Math.floor(Math.random() * (max - min)) + min;
}

function fancyUpdate() {
    $(".fancy").fancybox({
        prevEffect: 'none',
        nextEffect: 'none',
        helpers: {
            overlay: {
                locked: false
            }
        }
    });

    $(".fancybox-thumb").fancybox({
        prevEffect: 'none',
        nextEffect: 'none',
        helpers: {
            title: {
                type: 'outside'
            },
            thumbs: {
                width: 100,
                height: 100
            },
            overlay: {
                locked: false
            }
        }
    });

    $(".fancybox-frame-thumb").fancybox({
        prevEffect: 'none',
        nextEffect: 'none',
        arrows: false,
        helpers: {
            title: {
                type: 'outside'
            },
            thumbs: {
                width: 100,
                height: 100
            },
            overlay: {
                locked: false
            }
        }
    });
}
$(function () {
    fancyUpdate();
});
function updateAddCommentForm() {
    $('.addCommentForm').ajaxForm({
        beforeSubmit: function (arr, form, options) {
            $(form).find('button').addClass('disabled');
            $(form).find('.errors').html('');
        },
        data: {'antiBot': 1},
        success: function (data, statusText, xhr, form) {
            if (data.errors) {
                $(form).find('button').removeClass('disabled');
                var html = '<ul>';
                $.each(data.errors, function (index, value) {
                    html += '<li>' + value + '</li>';
                });
                html += '</ul>';
                $(form).find('.errors').html(html);
            } else {
                location.hash = '#comment-' + data.commentId;
                location.reload();
            }
        }
    });
}
updateAddCommentForm();

function commentReply(parentId) {
    $('.commentsList .item .addComment').remove();
    var newCommentForm = $('.addComment').clone();
    newCommentForm.find('input[name=parentId]').val(parentId);
    newCommentForm.find('.h2').remove();
    $('#comment-' + parentId + ' > .reply').after(newCommentForm);
    newCommentForm.find('textarea').focus();
    updateAddCommentForm();
}

function startStickyBlock() {
    var stickyElement = $('.stickyBlock');
    if (!stickyElement.length)
        return;
    $('<div class="clear" id="stickyBlockTop"></div>').insertBefore(stickyElement);
    var stickyBlockTopElement = $('#stickyBlockTop');
    var footerElement = $('footer');

    function stickyBlockCheck() {
        var scrollPosition = $(document).scrollTop();
        var stickyHeight = stickyElement.height();
        if (scrollPosition > stickyBlockTopElement.offset().top && $(window).width() >= 1041) {
            if (scrollPosition + stickyHeight > footerElement.offset().top) {
                stickyElement.css({
                    'top': footerElement.offset().top - (scrollPosition + stickyHeight) + 'px',
                    'position': 'fixed',
                    'width': stickyBlockTopElement.width() + 'px'
                });
            } else {
                stickyElement.css({
                    'top': 0,
                    'position': 'fixed',
                    'width': stickyBlockTopElement.width() + 'px'
                });
            }
        } else {
            stickyElement.removeAttr('style');
        }
    }

    $(window).scroll(stickyBlockCheck);
    $(window).resize(stickyBlockCheck);
}
startStickyBlock();

function addLinktoCopy() {

// Define tracking parameter
    var trackingparam = "utm_source=copypaste";

// Set document body as body_element variable
    var body_element = document.getElementsByTagName('body')[0];

// Create a selection variable to store copied value
    var selection;

// Create a selection to store the selection as a text string
    var selectedText;

// Populate selection variable with user's selected copy
    selection = window.getSelection();

// Populate selectedText variable with the user's selected copy stored as a string
    selectedText = selection.toString();

// Create a variable to store the selection length
    var selectionlength;

// Convert the selection to a string and get the string's length
    selectionlength = selection.toString().length

// If the selectionlength is >34 and doesn't start with "http://", then append tracking
// If the selection starts with "http://", it's likely a URL, which could provide for a bad experience when pasting into an address bar
    if ((selectionlength > 10) && (selectedText.substring(0, 7) != "http://")) {

        // Set the current page's URL as a variable
        var page = document.location.href;

        // Create a seperator variable
        var seperator;

        // Create a locationURL variable to store the URL and associated tracking parameters
        var locationURL;

        // Check to see if the URL already contains the tracking paramater
        // If the URL doesn't contain the tracking code, append it to the end
        if (page.indexOf(trackingparam) == -1) {

            // Check to see if the URL already includes a ? in it
            if (page.indexOf("?") != -1) {

                // If ? is present in the URL string, set seperator variable to &
                seperator = "&";

            }

            else {

                // If ? is not present in the URL string, set seperator variable to ?
                seperator = "?";

            }

            // Set locationURL variable with URL + tracking code
            locationURL = document.location.href + seperator + trackingparam;

        }

        // Othwerise, the tracking code already exists in the URL string, so append nothing
        else {

            // Set the locationURL variable with the URL as is
            locationURL = document.location.href;

        }

        // Build link to page with editorial copy, URL, seperator, and URL tracking parameters
        var pagelink = "<br/><br/>Источник: " + locationURL;

        // Create new variable with user's selection and page link
        var copytext = selection + pagelink;

        // Replace line breaks /n with HTML break tags to quasi-preserve formatting on paste
        copytext = copytext.replace(/\n/g, '<br />');

        // Create a new div and add associated styling and hide it off the page
        var newdiv = document.createElement("div");

        // Append new div to document
        body_element.appendChild(newdiv);

        // Select text from the new (hidden) div
        newdiv.innerHTML = copytext;

        // Replace clipboard values with new selection + link value
        selection.selectAllChildren(newdiv);

        window.setTimeout(function () {
            body_element.removeChild(newdiv);
        }, 0);

    }
}
document.oncopy = addLinktoCopy;
